module.exports = __webpack_public_path__ + "img/download.607d7b21.svg";